// @ts-check
// Menu "Iniciar bot" na conversa (contrato de bots, seções 19.2 e 22.4): os bots ativos com gatilho manual do número e
// da finalidade da conversa; escolher um começa o bot (a primeira mensagem dele sai na hora). Some quando não há bot
// manual ou quando a janela de 24 h está fechada (o bot só fala dentro dela).
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { listConversationBots, startConversationBot } from '../../data/bots.js';
import { showErrorSnackbar, showSuccessSnackbar } from '../../ui/snackbar.js';
import { FlowMenuButton } from '../flows/flow-menu.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ thread: { id: string, isServiceWindowOpen?: boolean | null }, onStarted?: () => void,
 *   onBotsLoaded?: (bots: Array<{ id: string, name: string }>) => void }} props
 *   onBotsLoaded: os bots manuais lidos (o menu de comandos oferece os mesmos)
 */
export function BotStartMenu({ thread, onStarted, onBotsLoaded }) {
  const [bots, setBots] = useState(/** @type {Array<{ id: string, name: string }>} */ ([]));
  useEffect(() => {
    let isCancelled = false;
    listConversationBots(thread.id).then((result) => {
      if (isCancelled) return;
      const loaded = result.run ? [] : result.bots;
      setBots(loaded);
      onBotsLoaded?.(loaded);
    }).catch(() => {
      if (isCancelled) return;
      setBots([]);
      onBotsLoaded?.([]);
    });
    return () => {
      isCancelled = true;
    };
  }, [thread.id]);
  if (bots.length === 0 || thread.isServiceWindowOpen === false) return null;
  /** @param {{ id: string, name: string }} bot */
  const start = async (bot) => {
    try {
      await startConversationBot(thread.id, bot.id);
      showSuccessSnackbar(t('bots.startMenu.started', { name: bot.name }));
      setBots([]);
      onBotsLoaded?.([]);
      onStarted?.();
    } catch (error) {
      showErrorSnackbar(error);
    }
  };
  return html`<div class="bot-start-menu" data-testid="bot-start-menu">
    <${FlowMenuButton} ariaLabel=${t('bots.startMenu.label')} label=${t('bots.startMenu.label')} icon="IconRobot" placement="bottom-end"
      className="flow-menu-trigger bot-start-trigger" items=${bots.map((bot) => ({ key: bot.id, text: bot.name, icon: 'IconPlayerPlay', onSelect: () => start(bot) }))} />
  </div>`;
}
